import React, {Component} from "react";
import CELBranding from "../../components/CELBranding";
import Account from "../../components/Account"
import ContextSearch from "../../components/ContextSearch"

const Layer1 = (props) => {

        return <div className="layer1">
            <Account />
            <ContextSearch context={props.context} entityId={props.entityId} /> 
            <CELBranding />
        </div>
}

export default Layer1;